import Vue from "vue";
import VueRouter from "vue-router";
import store from "./../store";
import util from "@/util/util.js";

const Login = () => import("@/components/Login.vue");
const NotFound = () => import("@/components/404.vue");
const DeleteRequest = () => import("@/components/DeleteRequest.vue");

//extra
const HomePage = () => import("@/views/HomePage.vue");
const Dashboard = () => import("@/components/admin/Dashboard.vue");
const Unauthorized = () => import("@/components/admin/extra/Unauthorized.vue");
const Landing = () => import("@/components/admin/extra/landing.vue");

//user
const Users = () => import("@/components/admin/users/index.vue");
const ActiveUsers = () => import("@/components/admin/users/active.vue");
const InactiveUsers = () => import("@/components/admin/users/inactive.vue");
const EditUser = () => import("@/components/admin/users/edit.vue");
const AssignRole = () => import("@/components/admin/users/assign-role.vue");
const CreateUser = () => import("@/components/admin/users/create.vue");
const ChangeUserPassword = () =>
  import("@/components/admin/users/changepassword.vue");
const DeletedUserList = () => import("@/components/admin/users/deleted.vue");
const AssignSiteToUser = () =>
  import("@/components/admin/users/assign-site.vue");

//role
const RoleList = () => import("@/components/admin/role/index.vue");
const CreateRole = () => import("@/components/admin/role/create.vue");
const EditRole = () => import("@/components/admin/role/edit.vue");
const AssignPermission = () =>
  import("@/components/admin/role/assign-permission.vue");

//timesheet
const TimesheetDateRange = () =>
  import("@/components/admin/timesheet/daterange.vue");
const EditTimesheet = () => import("@/components/admin/timesheet/edit.vue");
const AddTimesheet = () => import("@/components/admin/timesheet/create.vue");

//logged user section
// timesheet
const MyTimesheet = () => import("@/components/user/timesheet/index.vue");
const EditMyTimesheet = () => import("@/components/user/timesheet/edit.vue");
const CreateTimesheet = () => import("@/components/user/timesheet/create.vue");

const MyAttendance = () => import("@/components/user/attendance/index.vue");

const ResetPassword = () =>
  import("@/components/user/password/ResetPassword.vue");
const ChangePassword = () =>
  import("@/components/user/password/ChangePassword.vue");

const ForgotPassword = () =>
  import("@/components/user/password/ForgotPassword.vue");

// Attendance
const AttendanceDateRange = () =>
  import("@/components/admin/attendance/daterange.vue");
const EditAttendance = () => import("@/components/admin/attendance/edit.vue");
const AttendanceDeletedList = () =>
  import("@/components/admin/attendance/deleted.vue");

// today
const TodaysAttendance = () =>
  import("@/components/admin/attendance/today.vue");

const AttendanceByDate = () => import("@/components/admin/attendance/date.vue");

//site
const SiteList = () => import("@/components/admin/site/index.vue");
const CreateSite = () => import("@/components/admin/site/create.vue");
const EditSite = () => import("@/components/admin/site/edit.vue");
const AssignUsers = () => import("@/components/admin/site/assign-users.vue");
const UpdateCoordinate = () =>
  import("@/components/admin/site/update-coordinate.vue");

// site tracking point
const SiteTrackingPointList = () =>
  import("@/components/admin/site-tracking-point/index.vue");
const CreateSiteTrackingPoint = () =>
  import("@/components/admin/site-tracking-point/create.vue");
const EditSiteTrackingPoint = () =>
  import("@/components/admin/site-tracking-point/edit.vue");
const EditSiteTrackingPointCoordinate = () =>
  import("@/components/admin/site-tracking-point/update-coordinate.vue");

// tracking
const TrackingByDateRange = () =>
  import("@/components/admin/tracking/daterange.vue");
const TrackingByDate = () => import("@/components/admin/tracking/bydate.vue");

// Company;
const CompanyList = () => import("@/components/admin/company/index.vue");
const EditCompany = () => import("@/components/admin/company/edit.vue");

// logbook
const LogbookByDateRange = () =>
  import("@/components/admin/logbook/daterange.vue");
const LogbookByDate = () => import("@/components/admin/logbook/bydate.vue");
const EditLogbook = () => import("@/components/admin/logbook/edit.vue");

//site
const ShiftList = () => import("@/components/admin/shift/index.vue");
const CreateShift = () => import("@/components/admin/shift/create.vue");
const EditShift = () => import("@/components/admin/shift/edit.vue");

// Subscription
const SubscriptionList = () =>
  import("@/components/admin/subscription/index.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Landing,
    name: "Landing",
  },
  {
    path: "/login",
    component: Login,
    name: "Login",
  },
  {
    path: "/delete-request",
    component: DeleteRequest,
    name: "DeleteRequest",
  },
  {
    path: "/change-password",
    component: ChangePassword,
    name: "ChangePassword",
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
    name: "forgot-password",
  },
  {
    path: "/reset-password",
    component: ResetPassword,
    name: "ResetPassword",
  },
  {
    path: "/",
    component: HomePage,
    children: [
      {
        path: "/my-attendance",
        component: MyAttendance,
        name: "MyAttendance",
        beforeEnter: checkPermission,
        meta: { permission: "list-user-attendance" },
      },
      {
        path: "my-timesheet",
        component: MyTimesheet,
        name: "MyTimesheet",
        beforeEnter: checkPermission,
        meta: { permission: "list-user-timesheet" },
      },
      {
        path: "my-timesheet/create",
        component: CreateTimesheet,
        name: "CreateTimesheet",
        beforeEnter: checkPermission,
        meta: { permission: "add-timesheet" },
      },
      {
        path: "my-timesheet/:id/edit",
        component: EditMyTimesheet,
        name: "EditMyTimesheet",
        beforeEnter: checkPermission,
        meta: { permission: "edit-timesheet" },
      },
    ],
  },
  {
    path: "/admin",
    component: HomePage,
    children: [
      {
        path: "",
        component: Dashboard,
        name: "Dashboard",
      },
      {
        path: "timesheet",
        component: TimesheetDateRange,
        name: "TimesheetDateRange",
        beforeEnter: checkPermission,
        meta: { permission: "list-all-timesheet" },
      },
      {
        path: "timesheet/create",
        component: AddTimesheet,
        name: "AddTimesheet",
        beforeEnter: checkPermission,
        meta: { permission: "add-timesheet" },
      },
      {
        path: "timesheet/:id/edit",
        component: EditTimesheet,
        name: "EditTimesheet",
        beforeEnter: checkPermission,
        meta: { permission: "edit-timesheet" },
      },
      {
        path: "attendance",
        component: AttendanceDateRange,
        name: "Attendance",
        beforeEnter: checkPermission,
        meta: { permission: "list-all-attendance" },
      },
      {
        path: "attendance/:id/edit",
        component: EditAttendance,
        name: "EditAttendance",
        beforeEnter: checkPermission,
        meta: { permission: "edit-attendance" },
      },
      {
        path: "todays-attendance",
        component: TodaysAttendance,
        name: "TodaysAttendance",
        beforeEnter: checkPermission,
        meta: { permission: "list-all-attendance" },
      },
      {
        path: "attendance/by-date",
        component: AttendanceByDate,
        name: "AttendanceByDate",
        beforeEnter: checkPermission,
        meta: { permission: "list-all-attendance" },
      },
      {
        path: "attendance/deleted-list",
        component: AttendanceDeletedList,
        name: "AttendanceDeletedList",
        beforeEnter: checkPermission,
        meta: { permission: "list-all-attendance" },
      },
      {
        path: "user",
        component: Users,
        name: "Users",
        beforeEnter: checkPermission,
        meta: { permission: "list-user" },
      },
      {
        path: "user/create",
        component: CreateUser,
        name: "CreateUser",
        beforeEnter: checkPermission,
        meta: { permission: "add-user" },
      },
      {
        path: "user/active",
        component: ActiveUsers,
        name: "ActiveUsers",
        beforeEnter: checkPermission,
        meta: { permission: "list-user" },
      },
      {
        path: "user/inactive",
        component: InactiveUsers,
        name: "InactiveUsers",
        beforeEnter: checkPermission,
        meta: { permission: "list-user" },
      },
      {
        path: "user/:id/edit",
        component: EditUser,
        name: "EditUser",
        beforeEnter: checkPermission,
        meta: { permission: "edit-user" },
      },

      {
        path: "user/:id/assign-role",
        component: AssignRole,
        name: "AssignRole",
        beforeEnter: checkPermission,
        meta: { permission: "assign-role" },
      },
      {
        path: "user/:id/assign-site",
        component: AssignSiteToUser,
        name: "AssignSite",
        beforeEnter: checkPermission,
        meta: { permission: "assign-users-to-site" },
      },

      {
        path: "user/deleted-list",
        component: DeletedUserList,
        name: "DeletedUserList",
        beforeEnter: checkPermission,
        meta: { permission: "list-deleted-user" },
      },
      {
        path: "change-user-password/:id",
        component: ChangeUserPassword,
        name: "change-user-password",
        beforeEnter: checkPermission,
        meta: { permission: "change-password-admin" },
      },
      {
        path: "role",
        component: RoleList,
        name: "RoleList",
        beforeEnter: checkPermission,
        meta: { permission: "list-role" },
      },
      {
        path: "role/create",
        component: CreateRole,
        name: "CreateRole",
        beforeEnter: checkPermission,
        meta: { permission: "add-role" },
      },
      {
        path: "role/:id/edit",
        component: EditRole,
        name: "EditRole",
        beforeEnter: checkPermission,
        meta: { permission: "edit-role" },
      },
      {
        path: "role/:id/assign-permission",
        component: AssignPermission,
        name: "AssignPermission",
        beforeEnter: checkPermission,
        meta: { permission: "assign-permission" },
      },
      // site
      {
        path: "site",
        component: SiteList,
        name: "Sites",
        beforeEnter: checkPermission,
        meta: { permission: "list-site" },
      },
      {
        path: "site/create",
        component: CreateSite,
        name: "CreateSite",
        beforeEnter: checkPermission,
        meta: { permission: "add-site" },
      },
      {
        path: "site/:id/co-ordinate",
        component: UpdateCoordinate,
        name: "UpdateCoordinate",
        beforeEnter: checkPermission,
        meta: { permission: "update-site-coordinate" },
      },
      {
        path: "site/:id/edit",
        component: EditSite,
        name: "EditSite",
        beforeEnter: checkPermission,
        meta: { permission: "edit-site" },
      },
      {
        path: "site/:id/assign-users",
        component: AssignUsers,
        name: "AssignUsers",
        beforeEnter: checkPermission,
        meta: { permission: "assign-users-to-site" },
      },

      // shift
      {
        path: "shift",
        component: ShiftList,
        name: "Shift",
        beforeEnter: checkPermission,
        meta: { permission: "list-shift" },
      },
      {
        path: "shift/create",
        component: CreateShift,
        name: "CreateShift",
        beforeEnter: checkPermission,
        meta: { permission: "add-shift" },
      },
      {
        path: "shift/:id/edit",
        component: EditShift,
        name: "EditShift",
        beforeEnter: checkPermission,
        meta: { permission: "edit-shift" },
      },
      // tracking point
      {
        path: "site-tracking-point/:sid/list",
        component: SiteTrackingPointList,
        name: "SiteTrackingPointList",
        beforeEnter: checkPermission,
        meta: { permission: "list-site-tracking-point" },
      },
      {
        path: "site-tracking-point/:sid/create",
        component: CreateSiteTrackingPoint,
        name: "CreateSiteTrackingPoint",
        beforeEnter: checkPermission,
        meta: { permission: "add-site-tracking-point" },
      },
      {
        path: "site-tracking-point/:sid/edit/:id",
        component: EditSiteTrackingPoint,
        name: "EditSiteTrackingPoint",
        beforeEnter: checkPermission,
        meta: { permission: "edit-site-tracking-point" },
      },
      {
        path: "site-tracking-point/:sid/co-ordinate/:id",
        component: EditSiteTrackingPointCoordinate,
        name: "EditSiteTrackingPointCoordinate",
        beforeEnter: checkPermission,
        meta: { permission: "edit-site-tracking-point" },
      },

      // tracking data
      {
        path: "tracking/by-date",
        component: TrackingByDate,
        name: "TrackingByDate",
        beforeEnter: checkPermission,
        meta: { permission: "view-site-tracking-data-by-admin" },
      },
      {
        path: "tracking/by-daterange",
        component: TrackingByDateRange,
        name: "TrackingByDateRange",
        beforeEnter: checkPermission,
        meta: { permission: "view-site-tracking-data-by-admin" },
      },
      // logbook
      {
        path: "logbook",
        component: LogbookByDateRange,
        name: "LogbookByDateRange",
        beforeEnter: checkPermission,
        meta: { permission: "view-logbook-by-admin" },
      },
      {
        path: "logbook/by-date",
        component: LogbookByDate,
        name: "LogbookByDate",
        beforeEnter: checkPermission,
        meta: { permission: "view-logbook-by-admin" },
      },
      {
        path: "logbook/:id/edit",
        component: EditLogbook,
        name: "EditLogbook",
        beforeEnter: checkPermission,
        meta: { permission: "edit-logbook-by-admin" },
      },

      // company
      {
        path: "company",
        component: CompanyList,
        name: "CompanyList",
      },
      {
        path: "company/edit",
        component: EditCompany,
        name: "EditCompany",
        beforeEnter: checkPermission,
        meta: { permission: "edit-company" },
      },
      {
        path: "/unauthorized",
        component: Unauthorized,
        name: "Unauthorized",
      },
      // subscription
      {
        path: "subscription",
        component: SubscriptionList,
        name: "SubscriptionList",
      },
    ],
  },
  {
    path: "*",
    component: NotFound, // Catch-all route for undefined routes
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

let allowedPath = [
  "Login",
  "ResetPassword",
  "forgot-password",
  "DeleteRequest",
];
router.beforeEach((to, from, next) => {
  let isAuthenticated = localStorage.getItem("token");
  if (allowedPath.indexOf(to.name) != -1 && isAuthenticated)
    next({ name: "Dashboard" });
  if (to.name == "Login" && isAuthenticated) next({ name: "Dashboard" });
  if (allowedPath.indexOf(to.name) == -1 && !isAuthenticated)
    next({ name: "Login" });
  else next();
});

async function checkPermission(to, from, next) {
  let permissions = store.state.permissions;
  if (permissions.length == 0) {
    await util
      .http({
        url: "role/permissions/user-permissions",
      })
      .then((resp) => {
        store.state.permissions = permissions = resp.data.data;
      });
  }
  if (permissions.indexOf(to.meta.permission) != -1) {
    return next();
  } else return next({ name: "Unauthorized" });
}

export default router;
